import * as z from "../../../vendor/zod/src/index";
const ActionEntry = z.object({
    date: z.string(),
    action: z.any(),
});
export default z.object({
    actions: z.array(ActionEntry),
});
